module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/serum@3x_992351.png";